import store from "../store";

import { getMenuItemsForEventID } from "../components/DynamicCRF-generated.js";

function getNextCRF(dataTableID) {
  let menuItems = store.getters.getMenuItems;
  let idx = menuItems.findIndex((item) => item.id == dataTableID);
  if (idx != undefined && menuItems[idx + 1] != undefined) {
    return menuItems[idx + 1].id;
  }
}

function showFormAndMoveToIt(dataTableID, dataItemID) {
  store.commit("showMenuItems", { menuItemIds: [dataTableID], status: true });
  this.formRedirectBusy = true;
  let menuItem = store.getters.getMenuItems.find(
    (item) => item.id == dataTableID
  );
  this.$router.push(menuItem.to);
  store.commit("setDefaultPage", dataItemID ? dataItemID : "first");
}
function clearState() {
  store.commit("setFormAuthenticated", 0);
  store.commit("setFormGuid", null);
  store.commit("clearOnboardingFormData");
  store.commit("clearCurrentRoutePath");
  store.commit("setMenuItems", []);
  store.commit("setDefaultPage", "first");
}
function clearStateAndGoHome() {
  clearState();
  this.$router.push("/");
}

function onSubmitLastCRF() {
  let eventID = store.getters.getFormAuthenticated;
  function which_qt() {
    switch (eventID) {
      case "60":
        return "your first questionnaire";
      case "70":
        return "the 3-month questionnaire";
      case "80":
        return "the 6-month questionnaire";
      case "90":
        return "the 12-month questionnaire";
    }
  }
  this.dlgCustom.show(
    "Questionnaire Submission",
    `
            <p>You have reached the end of ${which_qt()}!</p>
            <p>Please make sure that you have <b>answered all the questions</b>.</p>
            <p>Once you click <b>submit</b>, you will <b>not</b> be able to <b>change</b> any of your <b>answers</b>.</p>
        `,
    [
      {
        caption: "Cancel",
        onClick: () => {
          this.dlgCustom.hide();
        },
      },
      {
        caption: "Submit",
        onClick: async () => {
          function followup_dlg_content() {
            switch (eventID) {
              case "70":
                return `
                                <p><b>Thank you</b> for <b>taking the time</b> to complete the questionnaire.</p>
                                <p>We will <b>contact</b> you <b>again</b> in <b>3 months’ time</b> asking you to <b>complete</b> another
                                    <b>questionnaire</b> so we can see how you have been doing.</p>
                                <p><b>Thank you from the ReSTORe Team</b></p>
                            `;
              case "80":
                return `
                                <p><b>Thank you</b> for <b>taking the time</b> to complete the questionnaire.</p>
                                <p>We will <b>contact</b> you <b>again</b> in <b>6 months’ time</b> asking you to <b>complete</b> another
                                    <b>questionnaire</b> so we can see how you have been doing.</p>
                                <p><b>Thank you from the ReSTORe Team</b></p>
                            `;
              case "90":
                return `
                                <p><b>Thank you</b> for <b>taking</b> the <b>time</b> to <b>complete</b> the questionnaire.</p>
                                <p>We <b>really appreciate it</b></p>
                                <p>This is the <b>last questionnaire for</b> the <b>ReSTORe</b> study.</p>
                                <p><b>Thank you from the ReSTORe Team</b></p>
                            `;
            }
          }

          this.dlgCustom.hide();
          if (eventID == 60) {
            let missing_required_items = await this.beginPost(
              `${this.baseUrl}OnSubmitBaseline_RequiredItemCheck`,
              { GUID: this.getFormGuid },
              "Please wait, saving form data."
            ).then((result) => this.endPost(result.data));

            if (missing_required_items.length > 0) {
              this.dlgCustom.show(
                "Missing Response(s)",
                `
                                <p>There was at least one question missed that we need a response to.</p>
                                <p>Pressing 'OK' will take you back to the first missing response.</p>
                                <p>Please can you fill in the missing answer then come back to this page to try re-submitting.</p>
                                <p>Thank you.</p>
                            `,
                [
                  {
                    caption: "OK",
                    onClick: () => {
                      let target = missing_required_items[0];
                      showFormAndMoveToIt.call(
                        this,
                        target.DataTableID,
                        target.DataItemID
                      );
                    },
                  },
                ]
              );
            } else {
              let result = await this.beginPost(
                `${this.baseUrl}OnSubmitBaseline`,
                { GUID: this.getFormGuid },
                "Please wait, saving form data."
              ).then((result) => this.endPost(result.data));
              if (!result.failed) clearState();

              this.dlgCustom.show("INFORMATION", result.message, [
                {
                  caption: "OK",
                  onClick: () => {
                    this.dlgCustom.hide();
                    if (!result.failed) clearStateAndGoHome.call(this);
                  },
                },
              ]);
            }
          } else {
            let missing_required_items = await this.beginPost(
              `${this.baseUrl}OnSubmitFollowUp`,
              { GUID: this.getFormGuid },
              "Please wait, saving form data."
            ).then((result) => this.endPost(result.data));

            if (missing_required_items.length > 0) {
              this.dlgCustom.show(
                "Missing Response(s)",
                `
                                <p>There was at least one question missed that we need a response to.</p>
                                <p>Pressing 'OK' will take you back to the first missing response.</p>
                                <p>Please can you fill in the missing answer then come back to this page to try re-submitting.</p>
                                <p>Thank you.</p>
                            `,
                [
                  {
                    caption: "OK",
                    onClick: () => {
                      let target = missing_required_items[0];
                      showFormAndMoveToIt.call(
                        this,
                        target.DataTableID,
                        target.DataItemID
                      );
                    },
                  },
                ]
              );
            } else {
              clearState();

              this.dlgCustom.show("Thank You", followup_dlg_content(), [
                {
                  caption: "OK",
                  onClick: () => {
                    this.dlgCustom.hide();
                    clearStateAndGoHome.call(this);
                  },
                },
              ]);
            }
          }
        },
      },
    ]
  );
}

export let crfCallbacks = {
  tbFrmScreeningCode: {
    onSubmit: async function () {
      let ScreeningCode = this.dataItemMap.ScreeningCode.dataItemValue;

      let result = await this.beginPost(
        `${this.baseUrl}ValidateScreeningCode`,
        { ScreeningCode },
        "Please wait, saving form data."
      ).then((result) => this.endPost(result.data));

      if (result.valid) {
        //debugger;
        store.commit("showMenuItems", {
          menuItemIds: ["tbFrmScreeningCode"],
          status: false,
        });
        store.commit("showMenuItems", {
          menuItemIds: ["tbFrmScreeningForm"],
          status: true,
        });

        this.$router.push("/screening-form");
      } else {
        this.dlgCustom.show("INFORMATION", result.message, [
          {
            caption: "OK",
            onClick: () => {
              this.dlgCustom.hide();
            },
          },
        ]);
      }
    },
  },
  tbFrmScreeningForm: {
    onLoad: function (route, next) {
      store.commit("showMenuItems", {
        menuItemIds: ["tbFrmScreeningForm"],
        status: true,
      });
      next();
    },
    onSubmit: async function () {
      let data = {};
      Object.assign(data, this.getOnboardingFormData.tbFrmScreeningForm);
      Object.assign(data, this.getOnboardingFormData.tbFrmScreeningCode);

      let result = await this.beginPost(
        `${this.baseUrl}MaybeSaveScreeningForm`,
        data,
        "Please wait, saving form data."
      ).then((result) => this.endPost(result.data));

      if (!result.passed) {
        this.showDialog(result.message, () => {
          clearStateAndGoHome.call(this);
        });
      } else {
        //Move to next form
        store.commit("showMenuItems", {
          menuItemIds: ["tbFrmContactDetails"],
          status: true,
        });
        this.formRedirectBusy = true;
        //this.$router.push(this.getNextCrfUrl);
        this.$router.push("/contact-details");
      }
    },
  },
  tbFrmContactDetails: {
    onSubmit: async function () {
      let data = {};
      Object.assign(data, this.getOnboardingFormData.tbFrmScreeningCode);
      Object.assign(data, this.getOnboardingFormData.tbFrmScreeningForm);
      Object.assign(data, this.getOnboardingFormData.tbFrmContactDetails);

      let result = await this.beginPost(
        `${this.baseUrl}SaveScreeningAndContactForm`,
        data,
        "Please wait, saving form data."
      ).then((result) => this.endPost(result.data));
      if (!result.IsDuplicate) {
        clearState(); //prevent resubmission via 'back'
      }

      this.showDialog(result.message, () => {
        if (!result.IsDuplicate) {
          store.commit("clearCurrentRoutePath");
          clearStateAndGoHome.call(this);
        }
        this.$router.push("/");
      });
    },
  },
  tbFrmEligibilityForm: {
    onSubmit: async function () {
      let result = await this.beginPost(
        `${this.baseUrl}OnSubmitEligibility`,
        { GUID: this.getFormGuid },
        "Please wait, saving form data."
      ).then((result) => this.endPost(result.data));
      clearState();

      this.showDialog(result.message, () => clearStateAndGoHome.call(this));
    },
  },
  tbFrmConsentForm: {
    onSubmit: async function () {
      let self = this;

      let checks = {
        csf_ReadInformationSheet: (v) => v == 2,
        csf_ParticipationIsVoluntary: (v) => v == 2,
        csf_RelevantMedicalNotes: (v) => v == 2,
        csf_GPBeingInformed: (v) => v == 2,
        csf_InformationCollectedSupportResearch: (v) => v == 2,
        csf_BeingContactedRestoreTeam: (v) => v == 2,
        csf_VideoTelephoneConsultation: (v) => v == 2,
        csf_HighlightHealthProblems: (v) => v == 2,
        csf_LoseCapacity: (v) => v == 2,
        csf_TakePartStudy: (v) => v == 2,
        csf_WCTUContactInterview: (v) => v != null,
        csf_TakePhotosVideo: (v) => v != null,
      };
      function do_checks() {
        for (let check in checks) {
          let value = self.dataItemMap[check].dataItemValue;
          let pass = checks[check](value);
          if (!pass) return false;
        }
        return true;
      }
      async function do_submit() {
        let result = await self
          .beginPost(
            `${self.baseUrl}OnSubmitConsent`,
            { GUID: self.getFormGuid },
            "Please wait, saving form data."
          )
          .then((result) => self.endPost(result.data));
        clearState();
        self.showDialog(result.message, () => clearStateAndGoHome.call(self));
      }

      let passed = do_checks();
      if (!passed) {
        this.dlgCustom.show(
          "INFORMATION",
          "You have answered No to one or more of the consent items. If you would like to update your answers please click Cancel, if not please click Submit.",
          [
            {
              caption: "Cancel",
              onClick: () => {
                this.dlgCustom.hide();
              },
            },
            {
              caption: "Submit",
              onClick: async () => {
                this.dlgCustom.hide();
                await do_submit();
              },
            },
          ]
        );
      } else {
        do_submit();
      }
    },
  },
  tbFrmDemographics: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmDemographics"));
    },
  },
  tbFrmChgOfContDtl: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmChgOfContDtl"));
    },
  },

  tbFrmRecentMedicalProblems: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmRecentMedicalProblems"));
    },
  },
  tbFrmYourOverallHealthBsl: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmYourOverallHealthBsl"));
    },
  },
  tbFrmHealthQuestions: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmHealthQuestions"));
    },
  },
  tbFrmQOL: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmQOL"));
    },
  },
  tbFrmPROMISNeuro: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmPROMISNeuro"));
    },
  },
  tbFrmQoLEQ5D5L_EQ5D: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmQoLEQ5D5L_EQ5D"));
    },
  },
  tbFrmIPAQSF: {
    onSubmit: async function () {
      let nextCRF = getNextCRF("tbFrmIPAQSF");
      if (nextCRF == undefined) onSubmitLastCRF.call(this);
      else showFormAndMoveToIt.call(this, nextCRF);
    },
  },
  tbFrmYourOverallHealth: {
    onSubmit: function () {
      showFormAndMoveToIt.call(this, getNextCRF("tbFrmYourOverallHealth"));
    },
  },
  tbFrmHealthSocialCareResourceUse: {
    onSubmit: async function () {
      let nextCRF = getNextCRF("tbFrmHealthSocialCareResourceUse");
      if (nextCRF == undefined) onSubmitLastCRF.call(this);
      else showFormAndMoveToIt.call(this, nextCRF);
    },
  },
  tbFrmStudyResults: {
    onSubmit: async function () {
      onSubmitLastCRF.call(this);
    },
  },
  tbFrmInterviewConsentForm: {
    onSubmit: async function () {
      await this.beginPost(
        `${this.baseUrl}OnSubmitInterviewConsent`,
        { GUID: this.getFormGuid },
        "Please wait, saving form data."
      ).then((result) => this.endPost(result.data));

      clearState();

      this.dlgCustom.show(
        "INFORMATION",
        `
                    <p>Form submitted, thank you.</p>
                `,
        [
          {
            caption: "OK",
            onClick: () => {
              this.dlgCustom.hide();
              clearStateAndGoHome.call(this);
            },
          },
        ]
      );
    },
  },
};

async function initEProEventRoute(route) {
  let state = store.state;
  let eventID = route.meta.eventID;
  let menuItemInfo = getMenuItemsForEventID(eventID);

  if (!menuItemInfo) {
    this.push("/");
    return;
  }

  store.commit("setFormAuthenticated", eventID);
  store.commit("setFormGuid", route.meta.formGuid);

  await store.dispatch("getGlobalFields");
  let enrolStatuses = state.globalFields.enrolStatuses;

  store.state.menuItems = menuItemInfo.getFilteredMenu(enrolStatuses);

  await store.dispatch("getFormCompleteness");

  function item_not_started(item) {
    return !item.formCompleteness || item.formCompleteness == "0%";
  }
  for (let i = store.state.menuItems.length - 1; i >= 0; --i) {
    let item = store.state.menuItems[i];
    if (item_not_started(item)) item.showMenuItem = false;
    else {
      if (
        i < store.state.menuItems.length - 1 &&
        item.formCompleteness == "100%"
      )
        store.state.menuItems[i + 1].showMenuItem = true;
      for (; i >= 0; --i) {
        store.state.menuItems[i].showMenuItem = true;
      }
      break;
    }
  }
  store.state.menuItems[0].showMenuItem = true;

  store.commit("setMenuItems", store.state.menuItems);
  store.commit("setMainMenuDrawer", true);

  let info = state.globalFields.sessionRestoreInfo
    ? JSON.parse(state.globalFields.sessionRestoreInfo)
    : {};

  let starting_url = info.lastEditedURL
    ? info.lastEditedURL
    : store.getters.getNextIncompleteCrfUrl;
  let starting_item = info.lastEditedItem ? info.lastEditedItem : "first";

  this.push(starting_url);

  store.commit("setDefaultPage", starting_item);
}

function initOnboardingRoute(route, next) {
  let eventID = route.meta.eventID;

  let menuItems = store.getters.getMenuItems;

  if (menuItems.length == 0) {
    let menuInfo = getMenuItemsForEventID(eventID);

    store.commit("setFormAuthenticated", eventID);
    store.commit("setMenuItems", menuInfo.menuItems);
    store.commit("setMainMenuDrawer", true);

    store.commit("showMenuItems", {
      menuItemIds: ["tbFrmScreeningCode"],
      status: true,
    });
  }

  next();
}

export let eventCallbacks = {
  10: { onLoad: initOnboardingRoute },
  20: { onLoad: initEProEventRoute },
  30: { onLoad: initEProEventRoute },
  60: { onLoad: initEProEventRoute },
  70: { onLoad: initEProEventRoute },
  80: { onLoad: initEProEventRoute },
  90: { onLoad: initEProEventRoute },
  100: { onLoad: initEProEventRoute },
};
